import { RESOURCE } from '@src/constants';
import { VIETQR_API_URL } from '@src/configs';
import api from './api';

const getTransferBanks = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.BANKS}/transfer`,
  });
  return response;
};

const getBanks = async () => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.BANKS,
  });
  return response;
};

const getUSDToVNDRate = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.BANKS}/usd-vnd-rate`,
  });
  return response;
};

const getAllBanks = async () => {
  const response = await api({
    method: 'GET',
    url: `${VIETQR_API_URL}/banks`,
  });
  return response;
};

const getBankPaymentInfo = async () => {
  const response = await api({
    method: 'GET',
    url: `/bank-payment-info`,
  });
  return response;
};

export {
  getTransferBanks,
  getBanks,
  getUSDToVNDRate,
  getAllBanks,
  getBankPaymentInfo,
};
